module.exports = __webpack_public_path__ + "img/join-top-bg.c3cda7df.png";